import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppEventsService {
  showSidebarSubject: Subject<boolean>;

  constructor() {
    this.showSidebarSubject = new Subject();
  }

  setShowSidebar(value: boolean) {
    this.showSidebarSubject.next(value);
  }
}
